import { marketToCountry } from "@/i18n/markets";

export function getLocalizedMarketName(
  market: string | null | undefined,
  language: string,
): string | null {
  if (!market) return null;
  const countryCode = marketToCountry(market);
  if (!countryCode) return null;

  try {
    return new Intl.DisplayNames([language], { type: "region" }).of(countryCode) || countryCode;
  } catch {
    return countryCode;
  }
}